module.exports = __webpack_public_path__ + "static/media/iPhone14_8.d6aff665.png";